export default __webpack_public_path__ + "static/media/Prashant Srivastava.2e6a59a5.jpg";